<div (click)="loadUrl(notification)">
  <span
    class="notification__item"
    [ngClass]="{active: !notification.clicked, 'notification__item--highligh': !notification.viewed}"
    [class.notification__clickable]="notification.clickable"
  >
    <img class="notification__picture" src="{{ notification.picture }}" width="40" height="40" />
    <div class="notification__infos">
      <p class="notification__text">
        <span class="notification__textAuthor"> {{ notification.textAuthor }} </span> {{ notification.textComplement }}
      </p>
      <p class="notification__date">{{ notification.date | date: 'fullDate' }}</p>
    </div>
    <img
      class="notification__product-picture"
      *ngIf="notification.itemUrl"
      src="{{ notification.itemUrl }}"
      width="40"
      height="40"
    />
  </span>
</div>
